import { render, staticRenderFns } from "./FacebookOAuthCallback.vue?vue&type=template&id=090feaf8&scoped=true"
import script from "./FacebookOAuthCallback.vue?vue&type=script&lang=js"
export * from "./FacebookOAuthCallback.vue?vue&type=script&lang=js"
import style0 from "./FacebookOAuthCallback.vue?vue&type=style&index=0&id=090feaf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090feaf8",
  null
  
)

export default component.exports